import script from "./tulView.vue?vue&type=script&setup=true&lang=js"
export * from "./tulView.vue?vue&type=script&setup=true&lang=js"

import "./tulView.vue?vue&type=style&index=0&id=61715e8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61715e8b"]])

export default __exports__